// extracted by mini-css-extract-plugin
export default {"alert":"FormAlert_alert__pessf","danger":"FormAlert_danger__Vkz84","success":"FormAlert_success__Gb-+I","icon":"FormAlert_icon__4dZ1Q","text":"FormAlert_text__GGPQl"};